import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { ProjectObjectsPage } from '@/pages/project-objects';
export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects'
)({
  component: ProjectObjectsPage,
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['grid', 'list']).optional(), 'list'),
      search: fallback(z.string().optional(), ''),
      filters: z.record(z.unknown()).optional(),
    })
  ),
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="estates" /> },
});
